<template>
  <div>
    <el-card style="margin-bottom: 20px">
      <el-row>
        <el-col class="flex-between">
          <div class="flex-items">
            <div class="flex-items">
              <div class="tui-rowTitle">学届：</div>
              <el-select
                v-model="levelListValue"
                placeholder="请选择学届"
                @change="onSelectLevel"
              >
                <el-option
                  v-for="item in levelList"
                  :key="item.Id"
                  :label="item.Name"
                  :value="item.Id"
                >
                </el-option>
              </el-select>
            </div>
            <div class="flex-items">
              <div class="tui-rowTitle">年级：</div>
              <el-select
                :popper-append-to-body="true"
                v-model="gradeValue"
                placeholder="请选择"
                @change="onSelectGrade"
              >
                <el-option
                  v-for="item in gradeList"
                  :key="item.Id"
                  :label="item.Name"
                  :value="item.Id"
                >
                </el-option>
              </el-select>
            </div>
            <div class="flex-items">
              <div class="tui-rowTitle">班级：</div>
              <el-select
                v-model="classListValue"
                placeholder="请选择"
                @change="onClassSelect"
              >
                <el-option
                  v-for="item in classList"
                  :key="item.Id"
                  :label="item.Name"
                  :value="item.Id"
                >
                </el-option>
              </el-select>
            </div>
            <div class="flex-items">
              <div class="tui-rowTitle">日期：</div>
              <div class="tui-picker" @click="onClickPicker">{{ Time }}</div>
              <!-- <el-date-picker
                v-model="Time"
                type="date"
                value-format="yyyy-MM-dd"
                @change="onChangeTime"
                placeholder="选择日期"
              >
              </el-date-picker> -->
              <!-- :picker-options="pickerOptions" -->
            </div>
          </div>

          <div class="flex-items">
            <el-button
              style="margin-left: 20px"
              type="goon"
              round
              @click.native="SportStudentList"
              >查询</el-button
            >
            <el-button
              type="danger"
              style="margin-left: 20px"
              round
              @click.native="onClickUnusual"
              >查看异常学生</el-button
            >
            <!-- <el-button style="margin-left: 20px" round @click.native="onReset"
              >清空</el-button
            > -->
          </div>
        </el-col>
      </el-row>
    </el-card>

    <!-- 列表 -->
    <el-row
      :gutter="20"
      v-if="List.length != 0"
      style="height: 9.5rem; overflow-y: scroll; display: flex; flex-wrap: wrap"
    >
      <div
        v-for="(item, index) in List"
        :key="index"
        style="margin-bottom: 20px; cursor: pointer"
        class="tui-widthCol"
      >
        <div
          class="grid-content bg-purple"
          @click="onClickDetail(item.StudentId, item)"
        >
          <div class="flex">
            <div class="tui-img">
              <img
                :src="
                  item.Sex == '男'
                    ? 'http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-12/2022-12-26/20221226160803_5774.png'
                    : 'http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-12/2022-12-26/20221226160817_3601.png'
                "
                alt=""
              />
            </div>
            <div class="tui-box">
              <div class="flex tui-userInfo">
                <div class="name">{{ item.StudentName }}</div>
                <img
                  src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-12/2022-12-26/20221226161123_9479.png"
                  alt=""
                />
                <div class="age">{{ item.Age }}</div>
              </div>
              <div style="padding: 0 10px 0 0; color: #67c23a">
                {{ item.GradeName }}{{ item.ClassName }}
              </div>
              <div class="flex" style="padding-top: 5px; height: 0.5rem">
                <div
                  class="tui-bages"
                  v-for="(cc, nn) in item.labelInfos"
                  :key="nn"
                  :style="getColors(cc.Status)"
                >
                  {{ cc.Name }}
                </div>
              </div>
            </div>
          </div>
          <div class="tui-border"></div>
          <div style="position: relative">
            <div class="circle-item">
              <!-- <canvas :id="'circle' + index" width="120px" height="120px">
              </canvas> -->
              <el-progress
                type="dashboard"
                :percentage="getNumData(Number(item.Heart))"
                :show-text="false"
                :color="
                  item.HeartColorStatus == 1
                    ? '#3FD4B7'
                    : item.HeartColorStatus == 2
                    ? '#FFBF4E'
                    : '#FE736D'
                "
                :stroke-width="10"
              ></el-progress>
              <!-- <canvas id="index" width="150px" height="120px"> </canvas> -->
              <div class="tui-position">
                <div class="">
                  <img
                    style="width: 30px; height: 30px"
                    src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-12/2022-12-22/20221222170718_3507.png"
                    alt=""
                  />
                </div>
                <div style="font-size: 0.25rem">{{ item.Heart }}</div>
                <div style="font-size: 0.15rem; color: #f3463a">
                  {{ item.HeartStatus }}
                </div>
              </div>
            </div>
            <div class="tui-positionRight">
              <div class="">
                步数 <span>{{ item.Step }}</span
                >步
              </div>
              <div class="">
                平均心率 <span>{{ item.AvgHeart }}</span
                >次/分
              </div>
              <div class="">
                最低心率 <span>{{ item.LowHeart }}</span
                >次/分
              </div>
              <div style="padding-top: 50rpx">
                最高心率 <span>{{ item.HighHeart }}</span
                >次/分
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-row>
    <!-- 无数据 -->
    <template v-if="List.length == 0">
      <el-card>
        <el-empty description="暂无数据"></el-empty>
      </el-card>
    </template>
    <el-dialog title="选择日期" :visible.sync="dialogVisible" width="30%">
      <div>
        <SimpleCalendar
          :unavailableContractDate="unavailableContractDate"
          @onDayClick="onDayClick"
          :ClassId="classListValue ? classListValue : 0"
        ></SimpleCalendar>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  getAcademicSelect,
  GetClassSelect,
  GetGradeList,
  SportStudentList,
  GetSportDateDedailByData,
  GetDateClassStuBaseInfo,
} from "../../api/api";
import SimpleCalendar from "../../components/SimpleCalendar/SimpleCalendar.vue";

export default {
  components: {
    SimpleCalendar,
  },
  data() {
    var _this = this;
    return {
      gradeValue: null,
      gradeList: [],
      studentList: [],
      addGradeList: [],
      userInfo: {},
      addlevelList: [],
      levelList: [],
      levelListValue: null,
      classList: [],
      classListValue: null,
      addClassList: [],
      Time: "",
      gradeId: 0,
      addGradeId: 0,
      studentName: "",
      List: [],
      timer: null,
      dialogVisible: false,
      unavailableContractDate: [],
    };
  },
  created() {
    this.userInfo = JSON.parse(window.localStorage.user);
  },
  async mounted() {
    await this.getNowTime();
    // await this.GetDateClassStuBaseInfo();
    await this.StudyYearSelectResult();
    await this.SportStudentList();
    if (this.isToday(this.Time)) {
      this.timer = setInterval(() => {
        //需要定时执行的代码
        this.SportStudentList();
      }, 3000);
    }

    //第一个是id，第二个百分比（圆弧到达位置）
  },
  beforeRouteLeave(to, from, next) {
    console.log("离开路由");
    clearInterval(this.timer);
    next();
  },
  methods: {
    isToday(date) {
      // 获取今天的日期
      var today = new Date();
      // 获取传入日期
      var inputDate = new Date(date);
      // 对比今天和传入日期
      if (today.toDateString() === inputDate.toDateString()) {
        return true;
      } else {
        return false;
      }
    },
    async onDayClick(e) {
      this.Time = e.date;
      if (this.isToday(this.Time)) {
        this.timer = setInterval(() => {
          //需要定时执行的代码
          this.SportStudentList();
        }, 3000);
      } else {
        clearInterval(this.timer);
        this.SportStudentList();
      }
      await this.SportStudentList();
      this.dialogVisible = false;
    },
    onClickPicker() {
      this.dialogVisible = true;
    },
    getdateNoTime(date) {
      var now = new Date(parseInt(date)),
        y = now.getFullYear(),
        m = now.getMonth() + 1,
        d = now.getDate();
      return y + "-" + (m < 10 ? "0" + m : m) + "-" + (d < 10 ? "0" + d : d);
    },

    async GetDateClassStuBaseInfo() {
      let res = await GetDateClassStuBaseInfo({
        Id: this.classListValue ? this.classListValue : 0,
        Time: this.Time,
        StudentId: 0,
      });
      if (res.data.success) {
        this.unavailableContractDate = res.data.response;
      }
    },
    // 查看异常学生
    onClickUnusual() {
      this.$router.push({
        path: "/DataMonitor/Unusual",
      });
    },
    getNumData(val) {
      if (val) {
        return Math.round(val / 2);
      }
    },
    onChangeTime(e) {
      this.SportStudentList();
    },
    async onClickDetail(StudentId, item) {
      let res = await GetSportDateDedailByData({
        Time: this.Time,
        StudentId: StudentId,
      });
      if (res.data.success) {
        this.$router.push({
          path: "/DataMonitor/detail",
          query: {
            Time: this.Time,
            StudentId: StudentId,
            labelInfos: JSON.stringify(item.labelInfos),
            ClassId: this.classListValue ? this.classListValue : 0,
          },
        });
      } else {
        this.$message({
          type: "error",
          message: res.data.msg,
        });
      }
    },
    async SportStudentList() {
      let res = await SportStudentList({
        StudentName: "",
        ClassId: this.classListValue ? this.classListValue : 0,
        Time: this.Time,
        GradeId: this.gradeValue ? this.gradeValue : 0,
      });
      if (res.data.success) {
        this.List = res.data.response;
      } else {
        this.List = [];
      }
    },

    getColors(val) {
      if (val !== 1) {
        return {
          background: "#FFF9ED",
          color: "#FFBF4E",
        };
      } else {
        return {
          background: "#F1FFF9",
          color: "#59E295",
        };
      }
    },
    async getNowTime() {
      let date = new Date();
      let y = date.getFullYear();
      let m = date.getMonth() + 1;
      let d = date.getDate();
      let time = y + "-" + m + "-" + d;

      this.Time = time;
    },
    // 重置
    onReset() {
      this.gradeValue = null;
      this.levelListValue = null;
      this.classListValue = null;
      this.Time = "";
    },
    // 年级下拉
    async GetGradeList() {
      let res = await GetGradeList({
        SchoolId: this.userInfo.SchoolId,
        StudyYearId: Number(this.levelListValue),
        Uid: this.userInfo.uID,
      });

      if (res.data.success) {
        if (
          this.userInfo.UserIdentity.indexOf("1") != -1 ||
          this.userInfo.UserIdentity.indexOf("0") != -1
        ) {
          let arr = [
            {
              Id: 0,
              Name: "全园",
            },
          ];
          this.gradeList = [...arr, ...res.data.response];
          this.gradeValue = this.gradeList[0].Id;
        } else {
          this.gradeList = res.data.response;
          this.gradeValue = res.data.response[0].Id;
        }
        await this.GetClassSelect();
      }
    },
    async onSelectGrade(val) {
      this.PageIndex = 1;
      this.gradeId = val;
      await this.GetClassSelect();
    },

    //   学届下拉
    async StudyYearSelectResult() {
      let res = await getAcademicSelect({
        SchoolId: this.userInfo.SchoolId,
        Uid: this.userInfo.uID,
      });
      if (res.data.success) {
        this.levelList = res.data.response;
        this.levelListValue = res.data.response[0].Id;
        await this.GetGradeList();
      }
    },
    onSelectLevel(e) {
      this.levelListValue = e;
      this.gradeList = [];
      this.gradeValue = null;
      this.classList = [];
      this.classListValue = null;
      this.GetGradeList();
    },

    async GetClassSelect() {
      let res = await GetClassSelect({
        SchoolId: this.userInfo.SchoolId,
        Uid: this.userInfo.uID,
        StudyYearId: Number(this.levelListValue),
        gradeId: this.gradeValue,
      });
      if (res.data.success) {
        this.classList = res.data.response;
        this.classListValue = res.data.response[0].Id;
      } else {
        this.classList = [];
        this.classListValue = null;
      }
    },
    onClassSelect(val) {
      this.PageIndex = 1;
      this.classId = val;
      this.SportStudentList();
    },
  },
};
</script>
<style lang="less" scoped>
.tui-picker {
  width: 2.75rem;
  font-size: 0.175rem;
  height: 0.45rem;
  line-height: 0.45rem;
  padding-left: 0.1875rem;
  border: 1px solid #dcdfe6;
  background-color: #fff;
  color: rgb(192, 196, 204);
  border-radius: 5px;
  cursor: pointer;
}
.tui-positionRight {
  position: absolute;
  right: 0;
  top: 0;
  display: flex;
  flex-direction: column;

  div {
    color: #333;
    font-size: 0.1rem;
  }

  span {
    color: #333;
    font-size: 0.25rem;
    font-weight: bold;
    padding: 0 0.0625rem;
  }
}
.tui-widthCol {
  width: calc(100% / 5 - 0.25rem);
  margin-right: 0.25rem;
}
.tui-widthCol:nth-child(5n) {
  margin-right: 0;
}
.grid-content {
  padding: 0.125rem 0.25rem;
  box-sizing: border-box;
}
.tui-position {
  position: absolute;
  text-align: center;
  top: 15%;
  left: 0;
  right: 0;
}
.circle-item {
  position: relative;
  width: 1.5rem;
}
.tui-border {
  width: 100%;
  height: 1px;
  border-bottom: 1px solid #f2f2f2;
  margin: 0.0625rem 0;
}
.tui-box {
  padding-left: 0.125rem;
  display: flex;
  flex-direction: column;
}
.tui-bages {
  padding: 0 0.125rem;
  height: 0.375rem;
  background: #f1fff9;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.15rem;
  margin-right: 0.0875rem;
  flex-shrink: 0;
}
.tui-userInfo {
  .name {
    color: #333333;
    font-size: 0.25rem;
    font-weight: bold;
  }
  .age {
    color: #666666;
    font-size: 0.225rem;
  }
  img {
    width: 0.2625rem;
    height: 0.25rem;
    padding: 0 0.125rem;
  }
}
.tui-img {
  width: 0.5rem;
  height: 0.5rem;
  display: flex;
  flex-shrink: 0;
  img {
    width: 100%;
    height: 100%;
  }
}
.el-button--goon {
  color: #fff;
  background-color: #27abf7;
  border-color: #27abf7;
  height: 34px;
  line-height: 34px;
  padding: 0 20px;
}
.tui-rowTitle {
  margin-left: 10px;
}
.bg-purple {
  background: #fbfbfb;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
}
</style>